import React from 'react';
import { Theme, makeStyles, useTheme, LinearProgress } from '@material-ui/core';
import { StyledText } from './StyledText';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    padding: '2px 2px',
    height: 'auto',
    width: 'max-content'
  },
  prog: {
    width: '100%',
    margin: '0px 5px',
    zIndex: 1,
    height: '5px'
  },
  dotsContainer: {
    position: 'relative',
    width: '25px'
  },
  dot: {
    position: 'absolute',
    zIndex: 2,
    backgroundColor: theme.palette.background.default,
    width: '5px',
    height: '5px'
  }
}));

interface Props {
  style?: React.CSSProperties | undefined
}

const CheckingForUpdates: React.FC<Props> = ({ style }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <div className={classes.root} style={{ ...(style || {}) }}>
      <StyledText>
        Checking for updates
      </StyledText>
      <div className={classes.dotsContainer}>
        <div className={classes.dot} style={{ left: '10px', top: 0 }} />
        <div className={classes.dot} style={{ left: '20px', top: 0 }} />
        <LinearProgress color='primary' variant='indeterminate' className={classes.prog} />

      </div>
    </div>
  );
};

export default CheckingForUpdates;
